import { Switch } from '@latitude/switch';
import React from 'react';

type BooleanFlagInputProps = {
  flagKey: string;
  value: boolean;
  onToggle: (key: string, value: boolean) => void;
};

export const BooleanFlagInput: React.FC<BooleanFlagInputProps> = ({
  flagKey,
  value,
  onToggle,
}) => {
  return (
    <div className="flex items-center justify-end">
      <Switch
        checked={value}
        onCheckedChange={(checked) => onToggle(flagKey, checked)}
      />
    </div>
  );
};
